import _BaseHttpService from './baseHttp.service'

class FileService extends _BaseHttpService {
  constructor () {
    super('file')
  }

  makePrivateLink (uid) {
    return this.constructor._endpoints(this.__key).downloadByUid.replace('{:id}', uid)
  }
}

export default FileService
